import queryString from "query-string";
const validCategories = {
  All: "",
  ".NET AI": "ai",
  ".NET Aspire": "aspire",
  ".NET MAUI": "maui",
  "ASP.NET": "aspnet",
  Data: "data",
  "Languages & Runtime": "languageandruntime",
};

// Validation method - check if category is a valid key OR value
const validateCategoryValue = (category) => {
  // Handle null, undefined cases
  if (category == null) return false;

  // Allow empty string (represents "All")
  if (category === "") return true;

  // Check if it's a valid key (full category name like ".NET AI")
  if (Object.prototype.hasOwnProperty.call(validCategories, category))
    return true;

  // Check if it's a valid value (short name like "ai")
  return Object.values(validCategories).includes(category);
};

// Helper method to convert URL parameter to internal state value (full category name)
const getInternalValueFromParent = (urlParam) => {
  // Handle null/undefined URL parameter
  if (!urlParam) return "";

  // Convert "All" to empty string
  if (urlParam === "all") return "";

  // Find the key (full category name) that has this value (short name)
  const categoryKey = Object.keys(validCategories).find(
    (key) => validCategories[key] === urlParam,
  );

  // If found, return the key (full category name), otherwise default to ""
  return categoryKey || "";
};

// Helper method to validate and sanitize category values (expects full category names)
const getSanitizedCategoryValue = (value) => {
  // If it's a valid key (full category name), use it
  if (Object.prototype.hasOwnProperty.call(validCategories, value)) {
    return value;
  }
  // If empty string (All), that's valid
  if (value === "") {
    return value;
  }
  return "";
};

// Helper method to convert full category display name to the API slug
const getCategoryApiSlug = (displayName) => {
  if (!displayName) return "";
  if (Object.prototype.hasOwnProperty.call(validCategories, displayName)) {
    return validCategories[displayName];
  }
  return "";
};

// Helper to send category selection to parent container
const sendOptionValueToParent = (value) => {
  // Validate and sanitize the value
  const sanitizedValue = getSanitizedCategoryValue(value);

  // Convert full category name to short URL value
  let categoryToSend;
  if (sanitizedValue === "" || sanitizedValue === "all") {
    categoryToSend = "all";
  } else {
    categoryToSend = validCategories[sanitizedValue] || "all";
  }

  // Get validated parent origin from query string
  const ValidDomains = require("../constants/valid-domain-list.json");
  const values = queryString.parse(window.location.search.toLowerCase());
  const domain = values.domain;

  // Only send to validated parent domains
  if (domain && ValidDomains[domain]) {
    window.parent.postMessage(
      {
        category: categoryToSend,
      },
      domain,
    );
  }
};

export {
  validCategories,
  validateCategoryValue,
  getInternalValueFromParent,
  getSanitizedCategoryValue,
  getCategoryApiSlug,
  sendOptionValueToParent,
};
